var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Telagram",
    clipPath: "url(#clip0_76_104600)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z",
    fill: "#34AADF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.1618 15.9132C10.1618 15.9132 15.1618 13.8612 16.8958 13.1387C17.5606 12.8497 19.8149 11.9248 19.8149 11.9248C19.8149 11.9248 20.8554 11.5202 20.7686 12.5028C20.7397 12.9075 20.5085 14.3236 20.2773 15.8554C19.9305 18.0231 19.5548 20.393 19.5548 20.393C19.5548 20.393 19.497 21.0578 19.0057 21.1734C18.5144 21.289 17.7051 20.7688 17.5606 20.6531C17.445 20.5665 15.393 19.2659 14.6416 18.63C14.4392 18.4566 14.208 18.1098 14.6704 17.7052C15.7109 16.7514 16.9536 15.5664 17.7051 14.815C18.0519 14.4681 18.3987 13.6589 16.9536 14.6415C14.9017 16.0578 12.8786 17.3872 12.8786 17.3872C12.8786 17.3872 12.4161 17.6762 11.5491 17.4161C10.682 17.156 9.6705 16.8092 9.6705 16.8092C9.6705 16.8092 8.9769 16.3757 10.1618 15.9132Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_104600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelagram);
export default __webpack_public_path__ + "static/media/telagram.2cef27a056687af5818e83f37d7d1184.svg";
export { ForwardRef as ReactComponent };